import { render, staticRenderFns } from "./BusquedaFactura.vue?vue&type=template&id=67ae21e9&scoped=true&"
import script from "./BusquedaFactura.vue?vue&type=script&lang=js&"
export * from "./BusquedaFactura.vue?vue&type=script&lang=js&"
import style0 from "./BusquedaFactura.vue?vue&type=style&index=0&id=67ae21e9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae21e9",
  null
  
)

export default component.exports